import { Component, OnInit } from '@angular/core';
import { NbDialogRef, NbToastrService, NbDialogService } from '@nebular/theme';
import { FormGroup, FormBuilder } from '@angular/forms';
import { AlertService } from '../../../../notification';

@Component({
  selector: 'ngx-dialog-prompt-prescription',
  templateUrl: './dialog-prompt-prescription.component.html',
  styleUrls: ['./dialog-prompt-prescription.component.scss'],
})
export class DialogPromptPrescriptionComponent {
  constructor(
    protected ref: NbDialogRef<DialogPromptPrescriptionComponent>,
    private fb: FormBuilder,
    protected alertService: AlertService,
    private toastrService: NbToastrService,
    private dialogService: NbDialogService,
  ) {}

  prescriptionForm: FormGroup;
  textAreaDefaultValue =
    'Rx: ABC Medicine (No Generics).\n PO - take 1 capsule twice a day, 1x after breakfast, 1x after dinner.\n refills: none.\n *Avoid alcohol';

  alertServiceOptions = {
    autoClose: true,
    keepAfterRouteChange: true,
  };

  dismiss() {
    this.ref.close();
  }

  savePrescription() {}

  prescribeMed() {
    this.toastrService.show('Medicine Added To Prescription List.', 'Success', {
      icon: 'checkmark-outline',
      status: 'success',
    });
    this.dismiss();
  }
}
